import * as React from "react";

import Layout from "../components/layout";
import Seo from "../components/seo";

export default function Post({ children, pageContext }) {
  


  return (
    <Layout>

      <article className="max-w-7xl mx-auto mt-24">
        {children}
      </article>
    </Layout>
  )
}